export default "__VITE_ASSET__DOPptdXp__"